module.exports = __webpack_public_path__ + "img/1475269438.91597ff6.jpg";